<template>
    <div :class="[
        'input-phone',
        { 'is-error': isError }
    ]">
        <input 
            v-model="inputValue" 
            placeholder="np. 609 000 000"
            maxlength="11"
            @input="onInput"
        />
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        value: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            inputValue: this.value.replace(/\s/gi, '')
        }
    },

    computed: {
        validatedValue() {
            return this.inputValue
        }
    },

    watch: {
        value: {
            handler: function(value) {
                this.inputValue = value
            },
            immediate: true
        }
    },

    mounted() {
        this.onInput()
    },

    methods: {
        onInput() {
            this.inputValue = this.inputValue.replace(/\s/gi, '')
            this.inputValue = this.inputValue.replace(/[^0-9.]/gi, '')

            let out = []
            for (let i = 0; i < this.inputValue.length; i++) {
                if (i === 3 || i === 6) {
                    out.push(' ')
                }

                out.push(this.inputValue[i])
            }

            this.inputValue = out.join('')

            this.$emit('input', this.inputValue)

            this.isError = false
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired(),
                this.validateAgainstPhoneRegex()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-phone {
    @include input-simple();

    input {
        @include size(100%, 38px);
    }
}
</style>